module.exports = __webpack_public_path__ + "static/media/step3inactive.f98824e7.svg";